import firebase from "firebase/app";

export default {
  name: 'DigitalSignageTv',
  data() {
    return {
      search: "",
    };
  },
  computed: {
    filteredChannels() {
      if (!this.search) {
        return this.digitalSignages;
      }

      return this.digitalSignages.filter((channel) =>
        channel.channelName.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    facilityId() {
      return this.$store.state.authModule.currentFacility;
    },
    digitalSignageTV() {
      return this.$store.state.digitalSignageModule.digitalSignageTV;
    },
    digitalSignages() {
      return this.$store.state.digitalSignageModule.currentDigitalSignageList.filter(x => x.channelName);
    },
    user() {
      return this.$store.state.authModule.user;
    }
  },
  watch: {
    digitalSignageTV(newValue, oldValue) {
      if(oldValue.isAuth && !newValue.isAuth) {
        this.$store.state.digitalSignageModule.subscribeOnDigitalSignageTV();
        this.$router.push('/digital-signage-tv-QR-code');
      }
    },
    async user(newValue, oldValue) {
      if(newValue.facilityId !== oldValue.facilityId) {
        try {
          await this.$store.dispatch("changeCurrentUserFacility", { newFacilityId: newValue.facilityId, redirectEnabled: false });
          await this.$store.dispatch("getDigitalSignages");
          this.$forceUpdate();
        } catch (err) {
          console.error(err)
        }
      }
    }
  },
  async created() {
    if(this.digitalSignageTV && this.digitalSignageTV?.isAuth) {
      if(this.user.facilityId !== this.$store.state.authModule.currentFacility) {
        try {
          await this.$store.dispatch("changeCurrentUserFacility", { newFacilityId: this.user.facilityId, redirectEnabled: false });
        } catch (err) {
          console.error(err)
        }
      }

      Promise.all([
        this.$store.dispatch("getDigitalSignages")
      ]).then(()=>{
        console.log("TV ID: ", this.digitalSignageTV.id);
        this.listLoading = false;
        this.$forceUpdate()
      })
    } else {
      this.$router.push("/digital-signage-tv-QR-code");
    }
  },
  methods: {
    async exit() {
      if(this.digitalSignageTV?.id) {
        await firebase
          .firestore()
          .collection("digitalSignageTV")
          .doc(this.digitalSignageTV.id)
          .update({
            isAuth: false,
            token: null,
            userId: null,
            userName: null,
            userStatus: null,
          }).then(() => {
            this.$router.push('/digital-signage-tv-QR-code')
          });
      }
    },
    redirectToDigitalSignage(id) {
      this.$router.push({ path: `/digital-signage/${this.facilityId}/v/${id}` });
    },
  },
};